define.alias("ember-intl/helpers/format-number", "settings/helpers/format-number");